import {PartnerIdentity} from './partner.model';
import {LocalizationIdentity} from './localization.model';
import {
    BeneficiaryInformation,
    Clause,
    CreditDefinition,
    GenericProductConfiguration,
    InsuredProduct,
    InsuredProductCpi,
    ProductConfigurationType,
    ProductIdentity
} from './product.model';
import {InsuredPerson, Policyholder} from './policy.model';
import {DictionaryItem} from './dictionary.model';
import {GenericEntity} from './generic-entity.model';
import {SystemUser} from './system-user.model';
import {Party} from './party.model';
import {FilledQuestionnaire} from './questionnaire.model';
import {CpiCalculationVariant} from './product-cpi.model';

export class Offer extends GenericEntity {
    partner: PartnerIdentity;
    localization: LocalizationIdentity;
    seller: SystemUser;
    number: string;
    status: DictionaryItem;
    statusDate: string;
    product: ProductIdentity;
    productType: ProductConfigurationType;
    insuredPerson: InsuredPerson;
    policyholder: Policyholder;
    insuredProduct: InsuredProduct;
    insuredPersonPolicyholder: boolean;
}

export class OfferCpi extends Offer {
    insuredProduct: InsuredProductCpi;
}

export class CpiOfferRecalculationRequest {
    creditValue: number;
    installmentCount: number;
    monthExtensionCount: number;
}

export class CpiSalesConfiguration extends GenericProductConfiguration {
    beneficiaryInformation: BeneficiaryInformation;
    clauseList: Clause[];
    configurationType: ProductConfigurationType.CPI;
    creditDefinition: CreditDefinition;
    insuranceEndDate: string;
    insuranceStartDate: string;
    party: Party;
    sumInsured: number;
    sumInsuredForTariff: number;
    variant?: CpiCalculationVariant;
    variantList: CpiCalculationVariant[];
    questionnaire: FilledQuestionnaire;

    constructor(props: CpiSalesConfiguration) {
        super();
        Object.assign(this, props);
        this.party = this.party ?? new Party();
        this.beneficiaryInformation = this.beneficiaryInformation ?? new BeneficiaryInformation();
    }

}

export enum OfferStatus {
    DRAFT = 'DRAFT',
    CANCELLED = 'CANCELLED',
    DONE = 'DONE',
}

export class OfferPg extends Offer {

}


